import { ErrorCode, FileRejection } from 'react-dropzone';

export const convertToMB = (bytes: number) => parseFloat((bytes / Math.pow(1000, 2)).toFixed(0));

export const wasUploadRejectedDueToTotalNumber = (filesRejected: FileRejection[]) =>
  !!filesRejected.filter(
    ({ errors }) => !!errors.filter(({ code }) => code === ErrorCode.TooManyFiles).length
  ).length;
